import { useState } from 'react'

import { Text } from '@wartek-id/text-v1'

import { Header } from 'app/KinerjaShared/components/Header'
import FilterButtons from 'app/KinerjaShared/components/FilterButtons'
import { FILTER_STATE } from 'app/KinerjaTimPenilaiPSPage/utils/status'
import TablePerencanaanPS from 'app/KinerjaTimPenilaiPSPage/components/TablePerencanaanPS'
import usePerencanaanList from 'app/KinerjaTimPenilaiPSPage/hooks/usePerencanaanList'
import useBasePath from 'app/KinerjaTimPenilaiPSPage/hooks/useBasePath'

import type {
  PerencanaanFilterState,
  TPerencanaanSummary,
} from 'types/kinerja-tim-penilai-ps'

const mapping: Record<
  Exclude<
    PerencanaanFilterState,
    'BELUM_DIAJUKAN_PENGAWAS' | 'DAPAT_DISETUJUI_SEKALIGUS'
  >,
  keyof TPerencanaanSummary
> = {
  ALL: 'total',
  SUDAH_DIAJUKAN_PENGAWAS: 'sudahDiajukanPengawas',
  BELUM_DISETUJUI_PEJABAT_PENILAI_KINERJA:
    'belumDisetujuiPejabatPenilaiKinerja',
  DIARAHKAN_REVISI_OLEH_TIM_KERJA: 'diarahkanRevisiOlehTimKerja',
  DIARAHKAN_REVISI_OLEH_PEJABAT_PENILAI_KINERJA:
    'diarahkanRevisiOlehPejabatPenilaiKinerja',
  SUDAH_DIREVISI_PENGAWAS: 'sudahDirevisiPengawas',
  DISETUJUI_PEJABAT_PENILAI_KINERJA: 'disetujuiPejabatPenilaiKinerja',
}

export default function TimPenilaiDaftarPSPage() {
  const [activeFilterState, setActiveFilterState] =
    useState<PerencanaanFilterState>('ALL')

  const { basePath, isPPKPengawasSekolahUrl: isPPKPengawasSekolah } =
    useBasePath()
  const { data, summary, isLoading, isFetched } = usePerencanaanList({
    filter: activeFilterState,
  })

  return (
    <div className="py-6 px-24 max-w-7xl m-auto">
      <Header title="Daftar Perencanaan Kinerja" className="mt-6" />
      <div className="bg-white mt-12 border-gray-30 border rounded">
        <div className="space-y-1 px-8 py-6">
          <Text variant="heading-md" as="h2">
            Cek Perencanaan yang sudah diajukan Pengawas
          </Text>
          <Text color="subdued">
            {isPPKPengawasSekolah
              ? 'Anda dapat setujui atau arahkan Pengawas untuk revisi.'
              : 'Anda dapat kirim ke Pejabat Penilai Kinerja untuk persetujuan atau arahkan Pengawas untuk revisi.'}
          </Text>
        </div>

        <div className="p-4">
          {isFetched && (
            <FilterButtons
              activeValue={activeFilterState}
              className="flex-wrap"
              onChange={(state) =>
                setActiveFilterState(state as PerencanaanFilterState)
              }
              items={Object.keys(mapping).map((state) => ({
                label: `${FILTER_STATE[state]} (${
                  summary[mapping[state as keyof typeof mapping]]
                })`,
                value: state as PerencanaanFilterState,
              }))}
            />
          )}
        </div>

        <TablePerencanaanPS
          basePath={basePath}
          data={data?.data ?? []}
          isLoading={isLoading}
        />
      </div>
    </div>
  )
}
